export function pushToDataLayer(data) {
  if (import.meta.server) return;
  if (!Array.isArray(window.dataLayer) && typeof window.dataLayer === "undefined") {
    window.dataLayer = [];
  }
  return window.dataLayer.push(data);
}
